<template>
    <div class="wrapper">
        <div class="panel-body">
            <h3>Importera från csv</h3>
            <div class="form-group">
                <label for="customers" class="control-label col-sm-3">Välj kund</label>
                <div class="col-sm-9">
                    <select id="customers" class="form-control">
                        <option v-for="customer in customers" :key="customer.id" :value="customer.id">{{ customer.data.name }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <label for="csv_file" class="control-label col-sm-3">Väl fil</label>
                <div class="col-sm-9">
                    <input type="file" id="csv_file" name="csv_file" class="form-control" @change="showImport()">
                </div>
            </div>
             <div class="col-sm-offset-3 col-sm-9">
                <a href="#" id="importBtn" style="display:none" class="btn btn-primary" @click="loadCSV()">Importera</a>
            </div>
            <!--<table v-if="parse_csv">
                <thead>
                    <tr>
                        <th v-for="key in parse_header" @click="sortBy(key)" :key="key" :class="{ active: sortKey == key }">
                        {{ key }}
                            <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
                            </span>
                        </th>
                    </tr>
                </thead>
                <tr v-for="csv in parse_csv" :key="csv">
                    <td v-for="key in parse_header" :key="key">
                    {{csv[key]}}
                </td>
                </tr>
            </table>-->
        </div>
    </div>
</template>

<script>
import { bus } from '../../main'
export default {
  name: 'Csvimport',
  data () {
    return {
      channel_name: '',
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders: {},
      sortKey: '',
      customers: {}
    }
  },
  mounted () {
    this.$http
      .get('/api/customers')
      .then(response => {
        this.customers = response.data.customers
      })
      .catch(error => console.log(error))
  },
  methods: {
    showImport () {
      document.getElementById('importBtn').style.display = 'inline-block'
    },
    sortBy: function (key) {
      var vm = this
      vm.sortKey = key
      vm.sortOrders[key] = vm.sortOrders[key] * -1
    },
    csvJSON (csv) {
      var vm = this
      var lines = csv.split('\n')
      var result = []
      var headers = lines[0].split(';')
      headers = headers.map(function (item) {
        return item.replace('\r', '')
      })
      vm.parse_header = lines[0].split(';')
      lines[0].split(',').forEach(function (key) {
        vm.sortOrders[key] = 1
      })
      lines.map(function (line, indexLine) {
        if (indexLine < 1) return // Jump header line
        var obj = {}
        var currentline = line.split(';')
        currentline = currentline.map(function (item) {
          return item.replace('\r', '')
        })
        headers.map(function (header, indexHeader) {
          obj[header] = currentline[indexHeader]
        })
        var CustomerSelect = document.getElementById('customers')
        var selectedCustomerValue = CustomerSelect.options[CustomerSelect.selectedIndex].value
        vm.onSave(selectedCustomerValue, obj)
        result.push(obj)
      })
      result.pop() // remove the last item because undefined values
      return result // JavaScript object
    },
    loadCSV () {
      var vm = this
      var fileUpload = document.getElementById('csv_file')
      if (window.FileReader) {
        var reader = new FileReader()
        reader.readAsText(fileUpload.files[0])
        // Handle errors load
        reader.onload = function (event) {
          var csv = event.target.result
          vm.parse_csv = vm.csvJSON(csv)
        }
        reader.onerror = function (evt) {
          if (evt.target.error.name === 'NotReadableError') {
            alert('Cannot read file !')
          }
        }
      } else {
        alert('FileReader are not supported in this browser.')
      }
    },
    onSave (customerId, place) {
      var url = '/api/customersplaces'
      this.$http
        .post(url, {
          customerPlace: {
            customerId: customerId,
            ...{
              data: place
            }
          }
        })
        .then(response => {
          bus.$emit('addedPlace', response.data)
        })
        .catch(error => console.log(error))
    }
  }
}
</script>

<style scoped>
    .panel {
  border: 2px solid #dfdfdf;
  box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0 0;
  margin: 10px;
}
.panel.panel-sm {
  max-width: 700px;
  margin: 10px auto;
}
.panel-heading {
  border-bottom: 2px solid #dfdfdf;
}
.panel-heading h1, .panel-heading h2, .panel-heading h3, .panel-heading h4, .panel-heading h5, .panel-heading h6 {
  margin: 0;
  padding: 0;
}
.panel-body .checkbox-inline {
  padding: 15px 20px;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/ImportData/CsvImport.vue